import { AppRoutingModule } from './app-routing.module';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { DatePipe } from '@angular/common';

import { AppComponent } from './app.component';
import { AuthInterceptorService } from './auth-interceptor.service';
import { MaterialModule } from './material/material.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpLoaderFactory } from './app-translate-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { HiringModule } from './3.hiring/hiring.module';
import { CategoryModule } from './2.category/category.module';
import { ContractsModule } from './4.contracts/contracts.module';
import { LoginModule } from './1.login/login.module';
import { PopupContratoExistenteComponent } from './core/shared/popup/popup-contrato-existente/popup-contrato-existente.component';
import { SipsModule } from './6.sips/sips.module';
import { P0ConsultModule } from './12.p0-consult/p0-consult.module';
import { CanalInternoModule } from './7.canal-interno/canal-interno.module';
import { ChannelHierarchyModule } from './5.admin/channel-hierarchy/channel-hierarchy.module';
import { AdministracionComponent } from './5.admin/administracion/administracion.component';
import { CommonComponentsModule } from "./common/common-components.module";
import { NgxFileDropModule } from 'ngx-file-drop';
import { ChannelListComponent } from './5.admin/administracion/channel-list/channel-list.component';
import { PopupConfirmacionComponent } from './core/shared/popup/popup-confirmacion/popup-confirmacion.component';
import { SharedComponentsModule } from './core/shared/components/shared-components.module';
import { ScoringModule } from './8.scoring/scoring.module';
import { PopupScoringComponent } from './core/shared/popup/popup-scoring/popup-scoring.component';
import { PopupBonoSocialComponent } from './core/shared/popup/popup-bono-social/popup-bono-social.component';
import { PopupOfertasKoComponent } from './core/shared/popup/popup-ofertas-ko/popup-ofertas-ko.component';
import { PopupGenericResponseComponent } from './core/shared/popup/popup-generic-response/popup-generic-response.component';
import { SharedModule } from './core/shared/shared.module';

import Aura from '@primeuix/themes/aura';
import { SpartanModule } from './spartan/spartan.module';

registerLocaleData(localeEs);

@NgModule({ declarations: [
        AppComponent,
        PopupContratoExistenteComponent,
        AdministracionComponent,
        ChannelListComponent,
        PopupConfirmacionComponent,
        PopupScoringComponent,
        PopupBonoSocialComponent,
        PopupOfertasKoComponent,
        PopupGenericResponseComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
    MatDatepickerModule,
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,

    NgbModule,
    AppRoutingModule,
    CategoryModule,
    HiringModule,
    LoginModule,
    MaterialModule,
    SharedModule,
    SipsModule,
    P0ConsultModule,
    ScoringModule,
    CanalInternoModule,
    ChannelHierarchyModule,
    MatExpansionModule,
    NgxFileDropModule,
    SharedComponentsModule,
    SpartanModule,
    TranslateModule.forRoot({
        defaultLanguage: 'es',
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    CommonComponentsModule],
        providers: [
          {
              provide: HTTP_INTERCEPTORS,
              useClass: AuthInterceptorService,
              multi: true
          },
          { provide: 'localeId', useValue: 'es' },
          { provide: LOCALE_ID, useValue: 'es-ES' },
          DatePipe,

          provideHttpClient(withXhr(), withInterceptorsFromDi())
        ] })
export class AppModule {

}
